/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './series.reducer';

export const Series = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const seriesList = useAppSelector(state => state.series.entities);
  const loading = useAppSelector(state => state.series.loading);
  const totalItems = useAppSelector(state => state.series.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="series-heading" data-cy="SeriesHeading">
        <Translate contentKey="tinyMedicRestApp.series.home.title">Series</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.series.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/series/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.series.home.createLabel">Create new Series</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.series.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {seriesList && seriesList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.series.id">Id</Translate> <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('seriesInstanceUid')}>
                  <Translate contentKey="tinyMedicRestApp.series.seriesInstanceUid">Series Instance Uid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('seriesInstanceUid')} />
                </th>
                <th className="hand" onClick={sort('seriesNumber')}>
                  <Translate contentKey="tinyMedicRestApp.series.seriesNumber">Series Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('seriesNumber')} />
                </th>
                <th className="hand" onClick={sort('seriesDescription')}>
                  <Translate contentKey="tinyMedicRestApp.series.seriesDescription">Series Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('seriesDescription')} />
                </th>
                <th className="hand" onClick={sort('bodyPartExamined')}>
                  <Translate contentKey="tinyMedicRestApp.series.bodyPartExamined">Body Part Examined</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bodyPartExamined')} />
                </th>
                <th className="hand" onClick={sort('patientPosition')}>
                  <Translate contentKey="tinyMedicRestApp.series.patientPosition">Patient Position</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientPosition')} />
                </th>
                <th className="hand" onClick={sort('laterality')}>
                  <Translate contentKey="tinyMedicRestApp.series.laterality">Laterality</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('laterality')} />
                </th>
                <th className="hand" onClick={sort('protocolName')}>
                  <Translate contentKey="tinyMedicRestApp.series.protocolName">Protocol Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('protocolName')} />
                </th>
                <th className="hand" onClick={sort('operatorsName')}>
                  <Translate contentKey="tinyMedicRestApp.series.operatorsName">Operators Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('operatorsName')} />
                </th>
                <th className="hand" onClick={sort('seriesDateTime')}>
                  <Translate contentKey="tinyMedicRestApp.series.seriesDateTime">Series Date Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('seriesDateTime')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.series.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.series.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.series.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.series.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.series.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('statusCode')}>
                  <Translate contentKey="tinyMedicRestApp.series.statusCode">Status Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('statusCode')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.series.study">Study</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.series.equipment">Equipment</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {seriesList.map((series, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/series/${series.id}`} color="link" size="sm">
                      {series.id}
                    </Button>
                  </td>
                  <td>{series.seriesInstanceUid}</td>
                  <td>{series.seriesNumber}</td>
                  <td>{series.seriesDescription}</td>
                  <td>{series.bodyPartExamined}</td>
                  <td>{series.patientPosition}</td>
                  <td>{series.laterality}</td>
                  <td>{series.protocolName}</td>
                  <td>{series.operatorsName}</td>
                  <td>
                    {series.seriesDateTime ? <TextFormat type="date" value={series.seriesDateTime} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>{series.microSec}</td>
                  <td>{series.timestampentry}</td>
                  <td>{series.lastupdated}</td>
                  <td>{series.cursor}</td>
                  <td>{series.active ? 'true' : 'false'}</td>
                  <td>{series.statusCode}</td>
                  <td>{series.study ? <Link to={`/study/${series.study.id}`}>{series.study.id}</Link> : ''}</td>
                  <td>{series.equipment ? <Link to={`/equipment/${series.equipment.id}`}>{series.equipment.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/series/${series.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/series/${series.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/series/${series.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.series.home.notFound">No Series found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={seriesList && seriesList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Series;
